var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48177 5.22265C7.70329 5.55493 7.46509 6 7.06574 6L0.934258 6C0.534911 6 0.296715 5.55493 0.518233 5.22265L3.58398 0.624037C3.78189 0.32717 4.21811 0.327171 4.41603 0.624037L7.48177 5.22265Z",
    fill: "#8F90A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingArrowUp);
export default __webpack_public_path__ + "static/media/Sorting_arrow_up.089081204974859dc5764a4d3f74e57d.svg";
export { ForwardRef as ReactComponent };